(function () {
  var root = document.querySelector('[data-widerruf]');
  if (!root) return;

  var apiUrl = root.getAttribute('data-api-url');
  var errValidation = root.getAttribute('data-err-validation');
  var errSubmit = root.getAttribute('data-err-submit');
  var form = root.querySelector('[data-step="form"]');
  var confirm = root.querySelector('[data-step="confirm"]');
  var success = root.querySelector('[data-step="success"]');
  var summary = root.querySelector('[data-summary]');
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function show(step) {
    [form, confirm, success].forEach(function (el) { el.hidden = el !== step; });
  }
  function showError(scope, msg) {
    var el = scope.querySelector('[data-error]');
    el.textContent = msg; el.hidden = false;
  }
  function clearError(scope) {
    var el = scope.querySelector('[data-error]');
    el.hidden = true; el.textContent = '';
  }
  function fields() {
    return {
      name: form.querySelector('[name="name"]').value.trim(),
      orderNumber: form.querySelector('[name="orderNumber"]').value.trim(),
      email: form.querySelector('[name="email"]').value.trim(),
      reason: form.querySelector('[name="reason"]').value.trim(),
      website: form.querySelector('[name="website"]').value
    };
  }

  // Stufe 1 → 2
  root.querySelector('[data-next]').addEventListener('click', function () {
    clearError(form);
    var f = fields();
    if (!f.name || !f.orderNumber || !EMAIL_RE.test(f.email)) {
      showError(form, errValidation);
      return;
    }
    function labelText(id) {
      var lbl = form.querySelector('label[for="' + id + '"]');
      return lbl ? lbl.textContent.replace(/\s*\*\s*$/, '').trim() : id;
    }
    summary.innerHTML = '';
    function addRow(term, value) {
      var dt = document.createElement('dt');
      dt.textContent = term;
      var dd = document.createElement('dd');
      dd.textContent = value;
      summary.appendChild(dt); summary.appendChild(dd);
    }
    addRow(labelText('w-name'), f.name);
    addRow(labelText('w-order'), f.orderNumber);
    addRow(labelText('w-email'), f.email);
    if (f.reason) addRow(labelText('w-reason'), f.reason);
    show(confirm);
  });

  // Stufe 2 → 1
  root.querySelector('[data-back]').addEventListener('click', function () {
    clearError(confirm); show(form);
  });

  // Stufe 2 → Absenden
  root.querySelector('[data-submit]').addEventListener('click', function () {
    clearError(confirm);
    var btn = this; btn.disabled = true;
    var f = fields();
    fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(f)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.j.ok) throw new Error(res.j.error || 'SERVER');
        root.querySelector('[data-success-time]').textContent = res.j.eingangAt;
        show(success);
      })
      .catch(function () {
        showError(confirm, errSubmit);
        btn.disabled = false;
      });
  });
})();
